import PerkboxToken from "../utils/PerkboxToken"

export default function getSessionId(accessToken: string) {
  try {
    const token = new PerkboxToken(accessToken)
    return token.get("sid")
  } catch (e) {
    return ""
  }
}
